import React from 'react';
import { LucideIcon } from 'lucide-react';

interface KpiCardProps {
  title: string;
  value: number;
  icon: LucideIcon;
  hint?: string;
}

const KpiCard: React.FC<KpiCardProps> = ({ title, value, icon: Icon, hint }) => (
  <div className="bg-white p-6 rounded-xl shadow-sm border hover:shadow-md transition-shadow">
    <div className="flex items-center justify-between">
      <div className="flex-1">
        <p className="text-sm font-medium text-gray-600">{title}</p>
        <p className="text-3xl font-bold text-gray-900 mt-1">{value.toLocaleString('vi-VN')}</p>
        {hint && <p className="text-xs text-gray-400 mt-1">{hint}</p>}
      </div>
      <div className="p-3 bg-blue-50 rounded-lg">
        <Icon className="h-8 w-8 text-blue-600" />
      </div>
    </div>
  </div>
);

export default KpiCard;
